import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    siteKey: String,
    submitSelector: { type: String, default: "[data-captcha-submit]" }
  }

  connect() {
    this.submitButtons = this.findSubmitButtons()
    this.setSubmitButtonsDisabled(true)
    this.retryCount = 0
    this.maxRetries = 40
    this.retryDelayMs = 250
    this.attemptRenderWidget()
  }

  disconnect() {
    if (this.retryTimer) {
      clearTimeout(this.retryTimer)
      this.retryTimer = null
    }

    if (this.widgetId && window.turnstile) {
      window.turnstile.remove(this.widgetId)
      this.widgetId = null
    }
  }

  attemptRenderWidget() {
    if (this.renderWidget()) return

    if (this.retryCount >= this.maxRetries) {
      this.setSubmitButtonsDisabled(false)
      return
    }

    this.retryCount += 1
    this.retryTimer = setTimeout(() => {
      this.retryTimer = null
      this.attemptRenderWidget()
    }, this.retryDelayMs)
  }

  renderWidget() {
    if (!window.turnstile || !this.siteKeyValue) return false

    if (this.widgetId) {
      window.turnstile.remove(this.widgetId)
    }

    this.widgetId = window.turnstile.render(this.element, {
      sitekey: this.siteKeyValue,
      theme: "light",
      size: "flexible",
      callback: () => this.setSubmitButtonsDisabled(false),
      "expired-callback": () => this.setSubmitButtonsDisabled(true),
      "error-callback": () => this.setSubmitButtonsDisabled(true)
    })

    return true
  }

  findSubmitButtons() {
    const form = this.element.closest("form")
    if (!form) return []

    return Array.from(form.querySelectorAll(this.submitSelectorValue))
  }

  setSubmitButtonsDisabled(disabled) {
    if (!this.submitButtons || this.submitButtons.length === 0) return

    this.submitButtons.forEach((button) => {
      button.disabled = disabled
    })
  }
}
